import React, { Component } from 'react'
import queryString from 'query-string';
import { isATSEnabled } from '../../action/auth';
import Page404 from '../../old_Components/Page404/Page404';
import Shimmer from '../../old_Components/Common/Shimmer';
import CandidateSearch from '../../old_Components/ATS/candidateSearch';
import { databaseSearch } from '../../action/databaseSearch';
export default class JobApplicationList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            COUNT: 0,
            SEARCHED_LIST: [],
            ATS_ENABLED: undefined,
            SHOW_LOADER: false,
            message: 'Enter Required Information to Find the Relevant Candidate.'
        }
    }

    componentDidMount() {
        document.title = 'Candidate Search - Hiring.JobzShala.com'
        isATSEnabled().then(res => {
            if (res.status) {
                this.setState({ ATS_ENABLED: res.result })
            }
        })
    }

    onSearch(model) {
        this.setState({ SHOW_LOADER: true })
        databaseSearch(model).then(res => {
            this.setState({ SHOW_LOADER: false })
            if (res.status) {
                if (res.result.SEARCHED_LIST.length > 0) {
                    this.setState({ SEARCHED_LIST: res.result.SEARCHED_LIST, COUNT: res.result.COUNT })

                } else {
                    this.setState({ message: 'No matching results found according to your search criteria.', SEARCHED_LIST: res.result.SEARCHED_LIST, COUNT: res.result.COUNT })
                }

            }
        })
    }

    render() {
        const { COUNT, SEARCHED_LIST, ATS_ENABLED, SHOW_LOADER, message } = this.state
        return (
            <React.Fragment>
                {ATS_ENABLED == undefined && <Shimmer />}
                {ATS_ENABLED == 1 && <CandidateSearch
                    message={message}
                    SEARCHED_LIST={SEARCHED_LIST}
                    COUNT={COUNT}
                    onSearch={(model) => this.onSearch(model)}
                    SHOW_LOADER={SHOW_LOADER}
                />}
                {ATS_ENABLED == 0 && <Page404 />}
            </React.Fragment>
        )
    }
}
